export default {
    beforeMount(el, binding) {
        el.clickOutsideEvent = function (event) {
            setTimeout(() => {
                if (!(el === event.target || el.contains(event.target))) {
                    binding.value(event);
                }
            }, 0);
        };
        document.body.addEventListener('mousedown', el.clickOutsideEvent);
    },
    unmounted(el) {
        document.body.removeEventListener('mousedown', el.clickOutsideEvent);
    },
};
